import { createContext } from 'react';

export const DirectDebitProcessContext = createContext({});
